import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React from "react";

export type HeaderManagerialAccountsProps = {
    createRoute?: string;
    mode?: 'list' | 'form';
    title?: string,
    subtitle?:string,
    extra?: React.ReactNode[],
}

export function HeaderCashFlow(props: HeaderManagerialAccountsProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();

    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Fluxo de Caixa'}
                mode={props.mode}
                subtitle={props.subtitle ?? 'Parametrização do Fluxo de Caixa'}
                onCreateLink={getCreateLink()}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                onCreateLabel={'Adicionar conta gerencial'}
                extra={props.extra}
            />
        </>
    );

}
